import DefaultAwardIcon from '@assets/icons/DefaultAwardIcon'
import { useDialog } from '@globals/dialog/useDialogStore'
import { AwardType } from '@kudos/http-client'
import EngagementDialogWithMobileDrawer from '@shared/dialog/EngagementDialogWithMobileDrawer'
import { FC } from 'react'
import AwardTypePointsChip from '../sendAward/AwardTypePointsChip'
import SendAwardForm from './SendAwardForm'
import { useSendAwardFormStore } from './useSendAwardFormStore'

export const SEND_AWARDS_MODAL_KEY = 'sendAwardsModalKey'
const SendAwardsModal: FC = () => {
  const { dialogData: award } = useDialog<AwardType>(SEND_AWARDS_MODAL_KEY)
  const { isFormDirty } = useSendAwardFormStore()

  return (
    award && (
      <EngagementDialogWithMobileDrawer
        dialogKey={SEND_AWARDS_MODAL_KEY}
        isFormDirty={isFormDirty}
        avatarUrls={award.attachmentUrls}
        defaultIcon={<DefaultAwardIcon />}
        chip={
          <AwardTypePointsChip
            points={award.points}
            pointsLocked={award.pointsLocked}
            isNomination={false}
          />
        }
        title={award.name}>
        <SendAwardForm awardType={award} />
      </EngagementDialogWithMobileDrawer>
    )
  )
}

export default SendAwardsModal
